import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import PrimeVue from "primevue/config";
import AutoComplete from "primevue/autocomplete";

loadFonts();

createApp(App)
  .use(vuetify)
  .use(router)
  .use(PrimeVue)
  .use(AutoComplete)
  .mount("#app");
